import { YoutubeData } from '../../../Content';

interface YoutubeContentProps {
  content: YoutubeData;
}

export const YoutubeContent: React.FC<YoutubeContentProps> = ({ content }) => {
  return (
    <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
      <iframe
        title="youtube-player"
        src={`https://www.youtube.com/embed/${
          content.youtubeID
        }?autoplay=1&modestbranding=1${
          content.startAt && `&start=${content.startAt}`
        }`}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};
